// https://github.com/moment/moment/issues/3650
export default function interopDefault(m) {
    return m["default"] || m;
}


//////////////////
// WEBPACK FOOTER
// /Users/jim/Documents/GitHub/ant-design-pro-site/scaffold/node_modules/_antd@3.6.4@antd/es/_util/interopDefault.js
// module id = null
// module chunks = 